import { ISPM_ResponseData } from '../../../spm/spm.interface';
import {IProductOrder__ProductList} from "@shared/interface/product-order.interface";

export class CreateSpmModel {
  private headerData = <ISPM_ResponseData>{};
  private productOrderList = <IProductOrder__ProductList[]>[]

  constructor(data?: ISPM_ResponseData) {
    if (data) this.HeaderData = data;
  }

  get HeaderData() {
    return this.headerData;
  }

  set HeaderData(val) {
    this.headerData = val;
  }

  get ProductOrderList() {
    return this.productOrderList;
  }

  set ProductOrderList(val) {
    this.productOrderList = val;
  }
}
